<template>
  <b-form-group>
    <template v-slot:label>
      <label class="form-group__label form-group__label--required">{{
        $t("dashboard.sms_message_data")
      }}</label>
    </template>
    <quill-editor-variables simple emitWithChangeSource v-model="message" :tags="tags">
      <template #btn-content>
        {{ $t("edit_campaign.sms_template_edit_title", "Description") }}
      </template>
      <template #description>
        {{
          $t(
            "edit_campaign.sms_template_var_description",
            "You can use these placeholders (variables) which will be replaced with actual donor-related values: [FIRST_NAME] = The donor’s First Name"
          )
        }}
      </template>
      <template #tags-full-text="{ tagsFull }">
        {{
          tagsFull
            ? $t("edit_campaign.sms_template_show_description", "Show")
            : $t("edit_campaign.sms_template_hide_description", "Hide")
        }}
      </template>
      <template #between-tags-and-editor="{ value }">
        <org-message-templates
          type="sms"
          :templateText="value"
          @update:templateText="(v) => (message = v)"
          :propTemplateId="templateId"
          @update:changeTemplate="changeTemplate"
        />
      </template>
    </quill-editor-variables>
    <template #description>
      <span :class="{ 'text-danger': charactersLeft < 0 }">
        {{ `${charactersLeftText} characters left` }}
      </span>
    </template>
  </b-form-group>
</template>

<script>
import { mapState } from "vuex";
import quillEditorVariables from "@/common-components/ui-elements/quill-editor-variables.vue";
import OrgMessageTemplates from "@/components/org-message-templates.vue";

export default {
  components: {
    quillEditorVariables,
    OrgMessageTemplates,
  },
  data() {
    return {
      message: "",
    };
  },
  props: {
    templateId: {
      type: Number,
      default: null,
    },
  },
  computed: {
    ...mapState({
      metas: (state) => state.campaign.metas,
    }),
    maxLength() {
      const campaignSmsSettings = this.metas["campaign_sms_settings"] || null;

      if (campaignSmsSettings?.value && campaignSmsSettings?.sms_text_len_limit) {
        return campaignSmsSettings.sms_text_len_limit;
      }

      return 160;
    },
    msgLength() {
      return new Blob([this.message]).size;
    },
    charactersLeft() {
      return this.maxLength - this.msgLength;
    },
    charactersLeftText() {
      const l = this.msgLength;
      return `(${l} / ${this.maxLength}) ${this.charactersLeft}`;
    },
    tags() {
      let options = [
        {
          value: "{{.Team.ID}}",
          text: this.$t("dashboard.email_message_tag_team_id", "Team ID"),
        },
        {
          value: "{{.Team.CampaignID}}",
          text: this.$t("dashboard.email_message_tag_team_campaign_id", "Team Campaign ID"),
        },
        {
          value: "{{.Team.Name}}",
          text: this.$t("dashboard.email_message_tag_team_name", "Team Name"),
        },
        {
          value: "{{.Team.Slug}}",
          text: this.$t("dashboard.email_message_tag_team_slug", "Team Slug"),
        },
        {
          value: "{{.Team.Description}}",
          text: this.$t("dashboard.email_message_tag_team_description", "Team Description"),
        },
        {
          value: "{{.Team.Goal}}",
          text: this.$t("dashboard.email_message_tag_team_goal", "Team Goal"),
        },
        {
          value: "{{.Team.LeaderName}}",
          text: this.$t("dashboard.email_message_tag_team_leader_name", "Team Leader Name"),
        },
        {
          value: "{{.Team.LeaderEmail}}",
          text: this.$t("dashboard.email_message_tag_team_leader_email", "Team Leader Email"),
        },
        {
          value: "{{.Team.ParentTeamID}}",
          text: this.$t("dashboard.email_message_tag_team_parent_team_id", "Team Parent Team ID"),
        },
        {
          value: "{{.Team.ParentTeamID2}}",
          text: this.$t("dashboard.email_message_tag_team_parent_team_id2", "Team Parent Team ID2"),
        },
        {
          value: "{{.Team.Group}}",
          text: this.$t("dashboard.email_message_tag_team_group", "Team Group"),
        },
        {
          value: "{{.Team.Hidden}}",
          text: this.$t("dashboard.email_message_tag_team_hidden", "Team Hidden"),
        },
        {
          value: "{{.Team.Nominated}}",
          text: this.$t("dashboard.email_message_tag_team_nominated", "Team Nominated"),
        },
      ];

      const allowTeamUpdateByPublicToken =
        this.metas["allow_team_update_by_public_token"]?.value || false;
      if (allowTeamUpdateByPublicToken) {
        options = [
          ...options,
          {
            value: "[TOKEN]",
            text: this.$t("dashboard.email_message_tag_token"),
          },
        ];
      }

      return options;
    },
  },
  methods: {
    changeTemplate(id) {
      this.$emit("templeteId", id);
    },
  },
};
</script>
